import React, { useState, useEffect, useRef } from "react"

const PenTool = ({ imageIndex, content_w, content_h }) => {

  const drawCanvasRef = useRef(null);
  const viewCanvasRef = useRef(null);

  const [toolInfo, setToolInfo] = useState({
    tool: 0,            // ツール番号 0:タッチ, 1:ペン, 2:マーカー, 3:消しゴム
    color: "#000000",   // ペン色
    size: 12,           // ペンサイズ
    opacity: 1.0        // ペン透明度
  });
  const [locusLog, setLocusLog] = useState([]);         // 描画ログ
  const [locusHistory, setLocusHistory] = useState([[]]); // 描画ログ履歴
  const [historyIndex, setHistoryIndex] = useState([]); // 表示中の描画ログ履歴番号
  const [isErase, setIsErase] = useState(false);        // 消しゴムフラグ
  const [TOOL_FINGER, TOOL_PEN, TOOL_MARKER, TOOL_ERASER] = [0, 1, 2, 3]; // ツール番号定義

  const imageIndexTotal = 32;        // 360度回転画像のindex数

  let drawPointerId = null;           // 描画フラグ(null以外：描画中)
  let isMove = false;                 // 移動フラグ
  let drawingLocusLog = {}            // 描き込み中の描画ログ
  let start_x, start_y, end_x, end_y; // 描画ログの始点/終点

  const [index, setIndex] = useState(imageIndex - 1);        // 表示する画角のインデックス
  const isLogOutput = false; // ログ出力フラグ

  useEffect(() => {
    // 画像数分用意
    let locusLogList = [];
    let locusHistoryList = [];
    let historyIndexList = [];
    
    for(let i = 0; i < imageIndexTotal; i++) {
      locusLogList.push([]);
      locusHistoryList.push([[]]);
      historyIndexList.push(-1);
    }
    setLocusLog(locusLogList);
    setLocusHistory(locusHistoryList);
    setHistoryIndex(historyIndexList);
  }, []);

  useEffect(() => {
    log('[imageIndex]');
    log(imageIndex);
    let _index = imageIndex - 1;
    setIndex(_index);

    // index変更のため、canvasの描画をすべて消去
    const viewContext = viewCanvasRef.current.getContext("2d");
    viewContext.clearRect(0, 0, content_w, content_h);
    
    // 「元に戻す」「やり直す」ボタンアイコンを無効化
    window.parent.ws_undo && window.parent.ws_undo.setStateTool(false);
    window.parent.ws_redo && window.parent.ws_redo.setStateTool(false);
       
    // 描画ログ履歴番号が初期値の場合、0を設定
    if (historyIndex[_index] === -1) {
      let tmpHistoryIndex = [...historyIndex];
      tmpHistoryIndex[_index] = 0;
      setHistoryIndex(tmpHistoryIndex);
    }
  }, [imageIndex]);

  useEffect(() => {
    log('[index]');
    log(index);

    // 履歴がない場合、描画しない
    if (locusLog[index] === undefined) { return };

    drawHistoryLog();
  }, [index]);

  /**
   * FFLからのイベント処理
   * @param {*} _evt - FFLからのメッセージイベント
   */
  function messageEvent(_evt) {
    const eventData = (_evt.data + "").split("[,]");
    log(eventData);

    //受信したmessageごとの処理
    if (eventData[0] === "FFLCOM_CHANGE_TOOL") {
      // ツール変更時
      let prop = {};
      if (typeof eventData[2] !== "undefined") {
        prop = JSON.parse(eventData[2]);
      }
      setCurrentToolInfo(eventData[1], prop);
    } else if (eventData[0] === "FFLCOM_CLEAR") {
      // 全消去ボタン押下時
      if (locusHistory[index][historyIndex[index]].length > 0) {
        let tmpLocusLog = [...locusLog];
        tmpLocusLog[index] = [];
        setLocusLog(tmpLocusLog);
      }
    } else if (eventData[0] === "FFLCOM_SET_MODE_FINGER") {
      // タッチボタン押下時
      setCurrentToolInfo(eventData[0], null);
    } else if (eventData[0] === "FFLCOM_ORIGINAL") {
      if (eventData[1] === "ws_eraser") {
        // 消しゴム押下時
        setCurrentToolInfo("FFLCOM_TOOL_ERASER", null);
      }
      else if (eventData[1] === "ws_undo") {
        log("ws_undo");
        log(index);
        // 元に戻す押下時
        const canUndo = historyIndex[index] > 0;
        if (canUndo) {
          let tmpHistoryIndex = [...historyIndex];
          tmpHistoryIndex[index] = tmpHistoryIndex[index] - 1;
          setHistoryIndex(tmpHistoryIndex);
        }
        else {
          window.parent.ws_undo.setStateTool(canUndo);
        }
      }
      else if (eventData[1] === "ws_redo") {
        log("ws_redo");
        log(index);
        // やり直すボタン押下時
        const canRedo = historyIndex[index] < (locusHistory[index].length - 1);
        if (canRedo) {
          let tmpHistoryIndex = [...historyIndex];
          tmpHistoryIndex[index] = tmpHistoryIndex[index] + 1;
          setHistoryIndex(tmpHistoryIndex);
        }
        else {
          window.parent.ws_redo.setStateTool(canRedo);
        }
      }
      else {
        // 上記以外のオリジナルボタン押下時はタッチ
        setCurrentToolInfo("FFLCOM_SET_MODE_FINGER", null);
      }
    } else if (eventData[0] === "FFLCOM_USERAPP_ON_READY") {
      // ローカル(FFLなし)起動
      let tmpLocusLog = [...locusLog];
      tmpLocusLog[index] = [];
      setLocusLog(tmpLocusLog);
    if (toolInfo.tool !== TOOL_FINGER) {
        drawCanvasRef.current.style.pointerEvents = "auto";
      }
    }
  }

  /**
   * ツールバーイベントリスナー登録/解除
   */
  useEffect(() => {
    window.addEventListener("message", messageEvent);
    return () => {
      window.removeEventListener("message", messageEvent);
    };
  }, [toolInfo, locusLog, historyIndex, index])

  /**
   * 描画開始イベント
   * @param {*} e - 描画開始時の座標イベント 
   */
  function downEvent(e) {
    e.preventDefault();
    if (drawPointerId === null && toolInfo.tool) {
      if (toolInfo.tool === TOOL_ERASER) {
        setIsErase(true);
      }
      else {
        // PointerIDで描画管理(2本指描画抑制)
        drawPointerId = e.pointerId;
        const drawContext = drawCanvasRef.current.getContext("2d");

        // 座標取得
        const pos = getDrawPosition(e);
        start_x = end_x = pos.x;
        start_y = end_y = pos.y;

        // 描画情報設定
        drawContext.strokeStyle = toolInfo.color;
        drawContext.globalAlpha = toolInfo.opacity;
        drawContext.lineWidth = toolInfo.size;
        drawContext.lineJoin = (toolInfo.tool === TOOL_PEN) ? "round" : "bevel";
        drawContext.lineCap = (toolInfo.tool === TOOL_PEN) ? "round" : "square";

        // 描き込み中描画ログの初期化
        drawingLocusLog = {
          tool: toolInfo.tool,
          color: toolInfo.color,
          opacity: toolInfo.opacity,
          size: toolInfo.size,
          position: []
        };
      }
    }
  }

  /**
   * 描画中イベント
   * @param {*} e - 描画中の座標イベント 
   */
  function moveEvent(e) {
    e.preventDefault();
    if (drawPointerId === e.pointerId) {
      isMove = true;
      const drawContext = drawCanvasRef.current.getContext("2d");

      // イベントで得られた座標を終点とする
      const pos = getDrawPosition(e);
      end_x = pos.x;
      end_y = pos.y;

      //マーカーの場合（垂直方向か水平方向か）
      if (toolInfo.tool == TOOL_MARKER) {
        drawContext.clearRect(0, 0, content_w, content_h);
        if (Math.abs(pos.x - start_x) >= Math.abs(pos.y - start_y)) {
          end_x = pos.x;
          end_y = start_y;
        } else {
          end_x = start_x;
          end_y = pos.y;
        }
      }
      else {
        //描画ログの配列に描画情報を追加
        drawingLocusLog.position.push({
          sx: start_x,
          sy: start_y,
          ex: end_x,
          ey: end_y
        });
      }

      // 描画用キャンバスに描画
      drawContext.beginPath();
      drawContext.moveTo(start_x, start_y);
      drawContext.lineTo(end_x, end_y);
      drawContext.stroke();

      // 現在の座標を次のイベントの始点とする
      if (toolInfo.tool != TOOL_MARKER) {
        start_x = end_x;
        start_y = end_y;
      }
    }
    else if (isErase) {
      // 消しゴム処理
      eraseDraw(e);
    }
  }

  /**
   * 描画終了イベント
   * @param {*}  e - 描画終了時の座標イベント
   */
  function upEvent(e) {
    e.preventDefault();
    if (drawPointerId === e.pointerId) {
      // キャンバスのクリア
      const drawContext = drawCanvasRef.current.getContext("2d");
      drawContext.clearRect(0, 0, content_w, content_h);

      //ペンの場合、かつmoveがない（クリック）場合
      //及び、マーカーの場合、このタイミングで記録する
      if (toolInfo.tool === TOOL_PEN && !isMove) {
        drawingLocusLog.position.push({
          sx: start_x + 1,
          sy: start_y,
          ex: start_x,
          ey: start_y
        });
      }
      else if (toolInfo.tool === TOOL_MARKER) {
        drawingLocusLog.position.push({
          sx: start_x === end_x ? start_x - 1 : start_x,
          sy: start_y,
          ex: start_x === end_x ? end_x + 1 : end_x,
          ey: end_y
        });
      }
      // 描画ログを更新して再描画 -> useEffect発火
      let _locusLog = [];
      Object.assign(_locusLog, locusHistory[index][historyIndex[index]]);
      _locusLog.push(drawingLocusLog);
      let tmpLocusLog = [...locusLog];
      tmpLocusLog[index] = _locusLog;
      setLocusLog(tmpLocusLog);

      isMove = false;
      drawPointerId = null;
    }
    else if (isErase) {
      if (!isMove) {
        // 消しゴム処理
        eraseDraw(e);
      }
      setIsErase(false);
    }
  }

  /**
   * 描画ログが更新されたら描画ログ履歴を更新する
   */
  useEffect(() => {
    log("[locusLog]");
    log(locusLog);
    // 学習記録ロード前は何もしない
    if (locusLog[index] === undefined) { return };

    // 履歴を戻ってから追加の描画をする際、戻っていた番号以降の履歴は不要なので切り捨てる
    let _locusHistory = locusHistory[index].slice(0, historyIndex[index] + 1);
    _locusHistory.push(locusLog[index]);
    let tmpLocusHistory = [...locusHistory];
    tmpLocusHistory[index] = _locusHistory;
    setLocusHistory(tmpLocusHistory);

  }, [locusLog]);

  /**
   * 描画ログ履歴が更新されたら履歴番号を更新する
   */
  useEffect(() => {
    log("[locusHistory]");
    log(locusHistory);
    // 学習記録ロード前は何もしない
    if (locusLog[index] === undefined && (historyIndex[index] === undefined || historyIndex[index] === -1)) { return }

    const _historyIndex = locusHistory[index].length - 1;
    log(_historyIndex);
    if (_historyIndex >= 0) {
      let tmpHistoryIndex = [...historyIndex];
      tmpHistoryIndex[index] = _historyIndex;
      setHistoryIndex(tmpHistoryIndex);
    }
  }, [locusHistory])

  /**
   * 履歴番号が更新されたら画面を再描画する
   */
  useEffect(() => {
    log("[historyIndex]");
    log(historyIndex);
    // 学習記録ロード前は何もしない
    if (locusHistory[index] === undefined || locusHistory[index].length === 0 || historyIndex[index] < 0) { return; }

    drawHistoryLog();

  }, [historyIndex])

  /**
   * 描画ログを描画する
   */
  function drawHistoryLog() {
    //まずcanvasの描画をすべて消す
    const viewContext = viewCanvasRef.current.getContext("2d");
    viewContext.clearRect(0, 0, content_w, content_h);

    //描画ログをはじめから順に描き直す
    locusHistory[index][historyIndex[index]].forEach((locus) => {
      viewContext.strokeStyle = locus.color;
      viewContext.globalAlpha = locus.opacity;
      viewContext.lineWidth = locus.size;
      viewContext.lineJoin = (locus.tool === TOOL_PEN) ? "round" : "bevel";
      viewContext.lineCap = (locus.tool === TOOL_PEN) ? "round" : "square";

      viewContext.beginPath();
      locus.position.forEach((pos) => {
        //描画ログの描画情報に合わせてcanvasに描画する
        viewContext.moveTo(pos.sx, pos.sy);
        viewContext.lineTo(pos.ex, pos.ey);
      });
      viewContext.stroke();
    });

    // 描画の有無で「全消去」ボタンアイコンを変更する
    window.parent.postMessage("FFLCOM_CALL_CHANGE_BTN_ICONS" + "[,]" + "fflcom_clear" + "[,]" + (locusHistory[index][historyIndex[index]].length === 0 ? 0 : 1), "*");

    // 履歴の有無で「元に戻す」「やり直す」ボタンアイコンを変更する
    window.parent.ws_undo && window.parent.ws_undo.setStateTool(historyIndex[index] > 0);
    window.parent.ws_redo && window.parent.ws_redo.setStateTool(historyIndex[index] < (locusHistory[index].length - 1));
  }

  /**
   * 消しゴム処理
   * @param {*} e - 座標イベント
   */
  function eraseDraw(e) {
    // 座標取得
    const eventPos = getDrawPosition(e);

    // 全ての描画ログを確認
    const currentlocusLog = locusHistory[index][historyIndex[index]];
    currentlocusLog.some((locus, i) => {
      // 消しゴムが描画範囲に接したか判定
      let hit = locus.position.some(function (locusPos) {
        var small_X = locusPos.sx <= locusPos.ex ? locusPos.sx : locusPos.ex;
        var large_X = locusPos.sx <= locusPos.ex ? locusPos.ex : locusPos.sx;
        var small_Y = locusPos.sy <= locusPos.ey ? locusPos.sy : locusPos.ey;
        var large_Y = locusPos.sy <= locusPos.ey ? locusPos.ey : locusPos.sy;
        var margin = locus.size / 2;
        return (((small_X - margin) <= eventPos.x && eventPos.x <= (large_X + margin)) && ((small_Y - margin) <= eventPos.y && eventPos.y <= (large_Y + margin)))
      });

      // 描画ログに接した場合、その描画を削除する
      if (hit) {
        // 描画ログを更新して再描画 -> useEffect発火
        let _locusLog = [...currentlocusLog];
        _locusLog.splice(i, 1);
        let tmpLocusLog = [...locusLog];
        tmpLocusLog[index] = _locusLog;
        setLocusLog(tmpLocusLog);
        return true;
      }
    });
  }

  /**
   * マウス・タッチ座標からcanvasの論理サイズを取得する
   * @param {*} e - 座標イベント 
   */
  function getDrawPosition(e) {
    let x, y = 0;
    if (e.touches && e.touches[0]) {
      x = e.touches[0].clientX;
      y = e.touches[0].clientY;
    }
    else if (e.originalEvent && e.originalEvent.changedTouches && e.originalEvent.changedTouches[0]) {
      x = e.originalEvent.changedTouches[0].clientX;
      y = e.originalEvent.changedTouches[0].clientY;
    }
    else if (e.clientX && e.clientY) {
      x = e.clientX;
      y = e.clientY;
    }
    const rc = drawCanvasRef.current.getBoundingClientRect();
    return {
      x: Math.round((content_w * (x - rc.left)) / (rc.right - rc.left)),
      y: Math.round((content_h * (y - rc.top)) / (rc.bottom - rc.top))
    };
  }

  /**
   * ツール情報を設定する
   * @param {*} _tool - ツールID
   * @param {*} _prop - 描画情報
   */
  function setCurrentToolInfo(_tool, _prop) {
    drawCanvasRef.current.style.pointerEvents = "auto";
    let currentToolInfo = {};
    if (_tool === "FFLCOM_TOOL_PEN") {
      currentToolInfo.tool = TOOL_PEN;
      currentToolInfo.color = _prop.color;
      currentToolInfo.size = (_prop.size * 1.5);
      currentToolInfo.opacity = _prop.opacity;
    } else if (_tool === "FFLCOM_TOOL_MARKER") {
      currentToolInfo.tool = TOOL_MARKER;
      currentToolInfo.color = _prop.color;
      currentToolInfo.size = (_prop.size * 1.5);
      currentToolInfo.opacity = _prop.opacity;
    } else if (_tool === "FFLCOM_TOOL_ERASER") {
      currentToolInfo.tool = TOOL_ERASER;
    } else {
      currentToolInfo.tool = TOOL_FINGER;
      drawCanvasRef.current.style.pointerEvents = "none";
    }
    setToolInfo(currentToolInfo);
  };

  useEffect(() => {
    drawCanvasRef.current.addEventListener("pointerdown", downEvent);
    drawCanvasRef.current.addEventListener("pointermove", moveEvent);
    drawCanvasRef.current.addEventListener("pointerup", upEvent);
    drawCanvasRef.current.addEventListener("pointerout", upEvent);
    drawCanvasRef.current.addEventListener("pointerleave", upEvent);
    drawCanvasRef.current.addEventListener("pointercancel", upEvent);
    return () => {
      drawCanvasRef.current.removeEventListener("pointerdown", downEvent);
      drawCanvasRef.current.removeEventListener("pointermove", moveEvent);
      drawCanvasRef.current.removeEventListener("pointerup", upEvent);
      drawCanvasRef.current.removeEventListener("pointerout", upEvent);
      drawCanvasRef.current.removeEventListener("pointerleave", upEvent);
      drawCanvasRef.current.removeEventListener("pointercancel", upEvent);
    }
  }, [toolInfo, isErase, historyIndex]);

  return (
    <>
      <canvas ref={drawCanvasRef} id="drawCanvas" width={content_w} height={content_h}
        style={{ position: "absolute", width: "100%", height: "100%", zIndex: 10000, pointerEvents: "none" }}
      />
      <canvas ref={viewCanvasRef} id="viewCanvas" width={content_w} height={content_h}
        style={{ position: "absolute", width: "100%", height: "100%", zIndex: 1000, pointerEvents: "none" }} />
    </>
  )

  function log(logMessage) {
    if (isLogOutput) {
      console.log(logMessage);
    }
  }
}

export default PenTool